import React from 'react';
import { StandardProps } from '@/newcar/ui/contract';

interface BaseGridFieldProps
  extends StandardProps {
  /**
   * @requires
   */
  children: React.ReactNode;

  /**
   * @default false
   */
  rowClassName?: string;
}
// #endregion

declare type GridProps = BaseGridFieldProps;

/**
 * Bulmaのグリッドシステム{columns}に該当するコンポーネント
 *
 * @export
 * @param {GridProps} props
 * @return {*}  {JSX.Element}
 */
// クラス調整
export default function Grid(props: GridProps): JSX.Element {
  const {
    className = '',
    rowClassName = '',
    children,
    style = {},
  } = props;
  return (
    <div
      className={`${className ?? ''}`}
      style={style}
    >
      <div className={`columns ${rowClassName}`}>
        {children}
      </div>
    </div>
  );
}
